<template>

    <v-alert  v-if="alertObj" :type="alertObj.type" :color="alertObj.color" :dismissible="alertObj.dismissible" :outlined="alertObj.outlined">
        {{alertObj.message}}
    </v-alert>

</template>

<script>
import {Alert, AppError} from '@/shared/models';

export default {
    name: 'AppAlert',
    props: ['alert'],
    data(){
        return {
            alertObj: null
        };
    },
    watch: {
        alert(newVal){
            if(newVal && newVal instanceof Alert){
                this.alertObj = newVal;
            }else if(newVal instanceof Error){
                this.alertObj = new AppError(newVal.message);
            }else{
                this.alertObj = new AppError('The object passed to the AppAlert component is not of type Alert');
            }
        }
    }
}
</script>